// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multiselect__option--highlight{background:#f0f0f0;color:#000}.container-dropdown-minha-localizacao input.dropdown-input{display:block!important;width:100%!important;max-width:100%!important;height:3em!important;font-size:1em!important}.container-dropdown-minha-localizacao .dropdown-content{width:100%!important;max-width:100%!important}.container-dropdown-minha-localizacao .dropdown-content .dropdown-item{font-size:1em!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
